import { render, staticRenderFns } from "./ClipboardSnackbar.vue?vue&type=template&id=7018f6c6&"
import script from "./ClipboardSnackbar.vue?vue&type=script&lang=ts&"
export * from "./ClipboardSnackbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports